var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ItemList_empty"},[_c('img',{attrs:{"alt":"Search Not Found","src":_vm.art}}),_c('h3',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }